import { AbsDropDown, Button, COLORS, Input, Label, Modal } from "abs-ui-components";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import axiosHttp from "../../../../../services/interceptor";
let fuelRegistryCache = null;
let fuelRegistryPromise = null;

const getFuelRegistry = async () => {
    if (fuelRegistryCache) {
        return fuelRegistryCache;
    }

    if (!fuelRegistryPromise) {
        fuelRegistryPromise = axiosHttp
            .get("/api/FuelRegistry/base")
            .then((response) => {
                fuelRegistryCache = response?.data?.data || [];
                return fuelRegistryCache;
            })
            .catch((error) => {
                fuelRegistryPromise = null;
                throw error;
            });
    }

    return fuelRegistryPromise;
};

const FieldInput = ({ field, row, value, error, onChange, disabled }) => {
    const { type, name, options = [] } = field;
    const [fuelReg, setFuelReg] = useState([]);
    useEffect(() => {
        let mounted = true;

        getFuelRegistry()
            .then((data) => {
                if (mounted) {
                    setFuelReg(data);
                }
            })
            .catch((error) => {
                console.error("Fuel registry error:", error);
            });

        return () => {
            mounted = false;
        };
    }, []);

    const handleNumericChange = (val) => {
        if (val === "") {
            onChange(name, val);
            return;
        }

        const regex = /^-?\d*\.?\d*$/;

        if (regex.test(val)) {
            onChange(name, val);
        }
    };
    const fuelOptions = useMemo(() => {
        const apiFuels = (fuelReg ?? [])
            .filter((f) => f.displayOnFE)
            .map((f) => ({
                label: f.fuelName,
                value: f.code,
                cf: f.cf,
                categoryType: f.categoryType,
            }));

        const customOptions = [
            {
                label: "Blend",
                value: "BLEND",
                cf: "",                 
                categoryType: "BLEND", 
            },
        ];

        return [...apiFuels, ...customOptions];
    }, [fuelReg]);

    const isRowField = row && Object.prototype.hasOwnProperty.call(row, "fuelType");
    const noFuelYet = isRowField && !row.fuelType;
    if (type === "fuel") {
        const isFromDatabase = row?.isFromDatabase === true;
        return (
            <div className="tall-input" style={{ position: "relative" }}>
                {isFromDatabase ? (
                    <Input
                        className="tall-input"
                        type="text"
                        value={value ?? ""}
                        disabled
                    />
                ) : (
                    <AbsDropDown
                        className="fuel-dropdown-wrap"
                        options={fuelOptions.map((o) => ({
                            label: o.label,
                            value: o.value,
                        }))}
                        selected={value}
                        handleChange={(val) => {
                            const selected = val?.value ?? val;
                            onChange(name, selected);

                            const match = fuelOptions.find(
                                (o) => o.value === selected
                            );

                            onChange("cf", match?.cf ?? "");
                        }}
                        placeholder="Select Fuel Type"
                        right={false}
                        search={false}
                    />
                )}

                {error && <div className="error-msg">{error}</div>}
            </div>
        );
    }
    const selectedFuel = fuelOptions.find(
        (o) => o?.value === row?.fuelType
    );
    const isFossil = selectedFuel?.categoryType === "Fossil";

    const raw = value ?? "";
    const isNegative = raw !== "" && Number(raw) < 0;
    if (name === "cf") {
        
        return (
            <div className="field-cell">
                <Input
                    className="tall-input"
                    type="text"
                    min="0"
                    value={raw}
                    disabled={disabled || noFuelYet || isFossil}
                   onChange={(e) => handleNumericChange(e?.target?.value ?? e)}
                />
                {isNegative && <div className="error-msg"
                style={{
                whiteSpace: "nowrap",
                lineHeight: "1.2",
                width: "max-content",
                position: "relative",
                zIndex: 10,
            }}
        >Negative values are not allowed.</div>}
            {error && <div className="error-msg"style={{
                whiteSpace: "nowrap",
                lineHeight: "1.2",
                width: "max-content",
                position: "relative",
                zIndex: 10,}}>{error}</div>}
            </div>

        );
    }

    return (
        <div className="field-cell">
            <Input
                className="tall-input"
                type="text"
                min="0"
                value={raw}
                disabled={disabled || noFuelYet}
                onChange={(e) => handleNumericChange(e?.target?.value ?? e)}
            />
            {isNegative && <div className="error-msg"
               style={{
                whiteSpace: "nowrap",
                lineHeight: "1.2",
                width: "max-content",
                position: "relative",
                zIndex: 10,
            }}
        >Negative values are not allowed.</div>}
            {error && <div className="error-msg"
            style={{
                whiteSpace: "nowrap",
                lineHeight: "1.2",
                width: "max-content",
                position: "relative",
                zIndex: 10,}}>{error}</div>}
        </div>

    );


};

export default FieldInput
